import { render, staticRenderFns } from "./WholesalersDashboard.vue?vue&type=template&id=08f3ecfa&scoped=true&"
import script from "./WholesalersDashboard.vue?vue&type=script&lang=js&"
export * from "./WholesalersDashboard.vue?vue&type=script&lang=js&"
import style0 from "./WholesalersDashboard.vue?vue&type=style&index=0&id=08f3ecfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f3ecfa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VIcon,VTab,VTabItem,VTabs,VTabsItems})
